import gql from 'graphql-tag'

export const PRODUTOS_QUERY = gql`
  query ProdutosQuery {
    produtos {
      id
      nome
      baseUriHomolog
      baseUri
    }
  }
`

export const EDITAR_PRODUTO = gql`
  mutation EditarProdutoMutation($produto: ProdutoInput!) {
    editarProduto(produto: $produto)
  }
`
